// import BudgetProgress, { ProgressType } from 'components/budgetProgress/budgetProgress';
import { Box, Group, Text } from '@mantine/core';
import React from 'react';

const FormInputWrapper = ({children, required, label, description, id,  labelWidth, style={marginTop:12,marginBottom:12}, labelPosition='center', direction='row'}) => {
   
    const lw = labelWidth?labelWidth:'20%';
    return (
        <Box style={style}>
            <div className="form-group row" style={{    
                display:'flex',
                gap:direction === 'column'?'4px':'20px',
                flexDirection:direction
            }}>
                <label className="col-form-label" style={{width:lw,flexShrink:0, display:'flex', flexDirection:'column',justifyContent:'flex-start', alignItems:labelPosition === 'top'?'flex-start':'flex-start'}}>
                    <Group sx={{gap:4, marginTop:4}}>
                        <Text size='sm'  weight='500'>{label}</Text>
                        {required?<Text size='sm' color={'red'} sx={{marginBottom:12}}>*</Text>:null}
                    </Group>
                    {description && description.length > 0?<Text size='xs' color="dimmed">{description}</Text>:null}
                </label>
                <div style={{flexGrow:1}}>
                    {children}
                </div>
            </div>
        </Box>
    )
}

export default FormInputWrapper;
